import { RTM_STATUSES } from '@/lib/oi/rtmStatus';
import { useInfraStore } from '@/lib/store/infra';
import { useOiStore } from '@/lib/store/oi';
import { useRtmStore } from '@/lib/store/rtm';
import { type Context, useUiStore } from '@/lib/store/ui';
import { DRONE_TOGGLES } from './droneToggles';

/** What the mobile Filters button says about the current tab (ENG-319): how many
 *  of its independent on/off filters are on. Pick-one tabs (Surveillance,
 *  Inventory, Data Stream) have no count, and the phone header has no room for
 *  a label, so they return null — the panel shows the pick when it opens. */
export type FilterSummary = { on: number; total: number } | null;

const OI_UI_FLAGS = 3; // Drone, Drone Projection, Geofences — beside the status chips

export function useFilterSummary(ctx: Context): FilterSummary {
  const droneOn = useUiStore((s) => DRONE_TOGGLES.filter((t) => s[t.key]).length);
  const oiFlagsOn = useUiStore(
    (s) => Number(s.showOIDrone) + Number(s.showOIDronePred) + Number(s.showGeofences),
  );
  const oiStatusOn = useOiStore((s) => RTM_STATUSES.filter((k) => s.filters[k]).length);
  const infraOn = useInfraStore(
    (s) =>
      Object.values(s.filterStatus).filter(Boolean).length +
      Object.values(s.filterType).filter(Boolean).length,
  );
  const infraTotal = useInfraStore(
    (s) => Object.keys(s.filterStatus).length + Object.keys(s.filterType).length,
  );
  const rtmOn = useRtmStore((s) => Object.values(s.filters).filter(Boolean).length);
  const rtmTotal = useRtmStore((s) => Object.keys(s.filters).length);

  switch (ctx) {
    case 'drones':
      return { on: droneOn, total: DRONE_TOGGLES.length };
    case 'oi':
      return { on: oiFlagsOn + oiStatusOn, total: OI_UI_FLAGS + RTM_STATUSES.length };
    case 'infra':
      return { on: infraOn, total: infraTotal };
    case 'rtm':
      return { on: rtmOn, total: rtmTotal };
    default:
      return null;
  }
}
